import { inject, Injectable } from '@angular/core';
import { LanguageStore } from '../data';
import { LanguageCode } from '@domain/language';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageFacade {
  readonly #store = inject(LanguageStore);
  readonly #translate = inject(TranslateService);

  public initialize(): void {
    const language = this.#store.language();
    this.#translate.use(language);
  }

  public changeLanguage(language: LanguageCode): void {
    this.#store.setLanguage(language as any);
    this.#translate.use(language);
  }
}
